import { del, get, post, put } from '../client';

export const villagesApi = {
  list: (params) => get('/villages', { params }),
  getById: (id) => get(`/villages/${id}`),
  create: (body) => post('/villages', body),
  update: (id, body) => put(`/villages/${id}`, body),
  remove: (id) => del(`/villages/${id}`),
};
